// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../../state/criteria';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import SpecialAllowanceClaimStatusCriteriaFooter from './criteria-footer';
import SpecialAllowanceClaimStatusInputCriteria from './input-criteria';

const SpecialAllowanceClaimStatusReportCriteria = props =>
    <div className='special-allowance-claim-status-report-criteria'>
        <div className='special-allowance-claim-status-criteria'>
            <SpecialAllowanceClaimStatusInputCriteria
                allowedTerritories={props.allowedTerritories}
                criteria={props.criteria}
                handleOriginalSubmissionDateSelect={props.handleOriginalSubmissionDateSelect}
                handleSelectAllTerritories={props.handleSelectAllTerritories}
                handleTerritorySelect={props.handleTerritorySelect}
            />
        </div>
        <SpecialAllowanceClaimStatusCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            handleCriteriaReset={props.handleCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateSpecialAllowanceClaimStatusReport}
        />
    </div>;

SpecialAllowanceClaimStatusReportCriteria.displayName = 'SpecialAllowanceClaimStatusReportCriteria';
SpecialAllowanceClaimStatusReportCriteria.propTypes = {
    allowedTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleCriteriaReset: PropTypes.func.isRequired,
    handleOriginalSubmissionDateSelect: PropTypes.func.isRequired,
    handleSelectAllTerritories: PropTypes.func.isRequired,
    handleTerritorySelect: PropTypes.func.isRequired,
    onCreateSpecialAllowanceClaimStatusReport: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired
};

export default SpecialAllowanceClaimStatusReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/components/special-allowance-claim-status-report-criteria/index.js